import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import utils from '../../utils/utils';

const AdminServiceAreaRow = ({ serviceArea }) => {
  const b2cTimeRanges = serviceArea.timeRanges.filter((tr) => !tr.isBusinessToBusiness);
  const b2bTimeRanges = serviceArea.timeRanges.filter((tr) => tr.isBusinessToBusiness);
  return (
    <tr>
      <th scope="row">
        <Link to={`/admin/serviceArea/${serviceArea.id}`} className="link">
          {serviceArea.id}
        </Link>
      </th>
      <td>{serviceArea.name}</td>
      <td>{serviceArea.description}</td>
      <td>{serviceArea.isHidden ? 'Hidden' : ''}</td>
      <td>
        <div>
          <div>
            <strong>B2C</strong>
          </div>
          {b2cTimeRanges.map((timeRange, index) => (
            <div key={index}>
              {timeRange.isBusinessToBusiness ? `B2B, ` : ''}
              {utils.getFormattedTimeRange(timeRange)}
              {timeRange.defaultLimit ? ` - Limit: ${timeRange.defaultLimit}` : ''} {timeRange.weekDays.join(', ')} #
              {timeRange.id}
            </div>
          ))}
        </div>
        <div>
          <div>
            <strong>B2B</strong>
          </div>
          {b2bTimeRanges.length
            ? b2bTimeRanges.map((timeRange, index) => (
                <div key={index}>
                  {timeRange.isBusinessToBusiness ? `B2B, ` : ''}
                  {utils.getFormattedTimeRange(timeRange)}
                  {timeRange.defaultLimit ? ` - Limit: ${timeRange.defaultLimit}` : ''} {timeRange.weekDays.join(', ')}{' '}
                  #{timeRange.id}
                </div>
              ))
            : '-'}
        </div>
      </td>
      <td>
        <Link to={`/admin/serviceAreas/edit/${serviceArea.id}`} className="link">
          Edit
        </Link>
      </td>
    </tr>
  );
};

AdminServiceAreaRow.propTypes = {
  serviceArea: PropTypes.object.isRequired,
};

AdminServiceAreaRow.defaultProps = {};

export default AdminServiceAreaRow;
